export default __webpack_public_path__ + "static/media/people.7948a917.svg";